import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFCFC] px-6">
      <div className="max-w-md w-full bg-white border border-border rounded p-10 text-center">
        <div className="overline">Payment cancelled</div>
        <h1 className="font-editorial text-3xl mt-2">No worries.</h1>
        <p className="text-sm text-slate-500 mt-2">You can try again anytime.</p>
        <Link to="/payment" data-testid="pay-retry-link" className="btn-bronze inline-block mt-6">Return to plans</Link>
      </div>
    </div>
  );
}
